export const MAX_LENGTH_TAG_NAME = 20;
